<template>
  <div>
    <div class="home_page">
      <div class="header">
        <span class="seeranking" @click="seeRanking">查看排行</span>
        <span class="myprize" @click="myPrize">我的奖品</span>
        <span class="activityrule" @click="rulePage">活动规则</span>
      </div>
      <div class="middle">
        <div>
          <img
            class="draw_btn"
            src="../assets/img/drawblindbox.png"
            @click="luckydraw"
          />
          <span>{{ surTimes }}</span>
        </div>
        <div class="mid_btn">
          <img src="../assets/img/getfrequency.png" @click="getmore" />
          <img src="../assets/img/Receive.png" @click="blindprizePage" />
        </div>
        <img
          class="broadcast_btn"
          src="../assets/img/livebtn.png"
          @click="goto(num, 'type')"
        />
      </div>
      <img class="mycode" src="../assets/img/fd_icon.gif" @click="goinvite" />
      <div class="footer">
        <img src="../assets/img/invitation.png" @click="goinvite" />
        <img src="../assets/img/drawLucky.png" @click="gotobuf(num, 'type')" />
      </div>

      <!--抽取盲盒弹框-->
      <van-popup style="background: none" v-model="popupshow">
        <div class="prizeTips">
          <div class="hqxcs">{{ xzyname }}</div>
          <div class="xzy">
            <span><img class="xzy_left" :src="xzyLogoUrl" /></span>
            <span><img class="xzy_right" :src="prizeLogoUrl" /></span>
          </div>

          <div class="prizename">{{ prizeName }}</div>
          <div class="btn">
            <img src="../assets/img/seeprize_btn.png" @click="myPrize" />
            <img src="../assets/img/again_btn.png" @click="luckydraw" />
            <span>{{ surTimes }}</span>
          </div>
        </div>

        <img
          src="../assets/img/close_btn.png"
          class="close"
          @click="popupshow = false"
        />
      </van-popup>

      <div
        class="background"
        @touchmove.prevent
        @click="hidepopup"
        v-show="show"
      ></div>
      <div class="content" v-show="show" @touchmove.prevent>
        <span class="frequency">(1/1)</span>
        <span class="frequency">({{ share }}/1)</span>
        <span class="frequency">({{ invite }}/20)</span>
        <span class="frequency">({{ kzb }}/1)</span>
        <img src="../assets/img/complete_btn.png" class="btn complete_btn" />
        <span>
          <img
            v-if="share == 1"
            src="../assets/img/complete_btn.png"
            class="btn share_btn"
          />
          <img
            v-else
            src="../assets/img/share_btn.png"
            class="btn share_btn"
            @click="goshare"
          />
        </span>
        <img
          src="../assets/img/Invite_btn.png"
          class="btn Invite_btn"
          @click="goinvite('confirm')"
        />
        <span>
          <img
            v-if="kzb == 1"
            src="../assets/img/complete_btn.png"
            class="btn goto_btn"
          />
          <img
            v-else
            src="../assets/img/goto_btn.png"
            class="btn goto_btn"
            @click="goto"
          />
        </span>
        <span>
          <img
            v-if="gmzzfw == 1"
            src="../assets/img/complete_btn.png"
            class="btn tobuf_btn"
          />
          <img
            v-else
            src="../assets/img/tobuf_btn.png"
            class="btn tobuf_btn"
            @click="gotobuf"
          />
        </span>
      </div>
      <div
        class="share_cover"
        v-if="sharePage"
        @click="sharePage = false"
      ></div>
    </div>
    <div class="photo">
      <img src="../assets/img/tgzq.png" @click="gotgzq" />
    </div>
  </div>
</template>

<script>
import { openService } from "@/utils/common";
import config from "../config/index";

import {
  pageBuryingPoint,
  eventBuryingPoint,
  DestructyBuryingPoint,
} from "@/utils/BuryingPoint";
import fetch from "@/utils/fetch";
import { Dialog } from "vant";
import { showToast, pageRecord, setHtmlTitle } from "@/utils/h5";

export default {
  name: "HomePage",
  data() {
    return {
      subCode: "lcj_lottery",
      loginFlag: this.$root.loginFlag, //登陆状态
      accountNo: "",
      sbCode: "", //设备唯一标识码
      fdshow:false,//默认不显示福袋
      rotation: "", //顶部轮播内容
      sharePage: false, //提示右上角遮罩
      surTimes: 0, //抽盲盒次数
      prizeName: "", //盲盒抽中奖品
      popupshow: false, //抽奖结果提示
      show: false, //获取次数
      share: 0, //是否完成分享
      invite: 0, //邀请次数
      kzb: 0, //直播次数
      gmzzfw: 0, //是否完成购买增值服务
      prizeLogoUrl: "", //盲盒奖品图片地址
      xzyLogoUrl: "", //小状元图片地址
      xzyname: "", //小状元名称
      titels: "", //小状元轻提示
      flag: true, //小状元弹框
      fromrouter: "",
    };
  },

  created() {
    setHtmlTitle("818理财节");
    // 验证账号
    fetch.post("/wxyx/cookie", {}).then((res) => {
      this.init();
    });
    pageRecord(this.subCode); //增加页面访问记录
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        from.name == "Pselection" ||
        from.name == "Rule" ||
        from.name == "Blindprize" ||
        from.name == "Livebroadcast" ||
        from.name == "RankingList" ||
        from.name == "Myprize" ||
        from.name == "Tgspecialarea"
      ) {
        vm.fromrouter = "other";
        return;
      } else {
        vm.fromrouter = "app";
        return;
      }
    });
  },
  beforeDestroy() {
    //页面销毁前
    DestructyBuryingPoint("p_ytwx818lcj_01");
  },
  mounted() {},
  methods: {
    hidepopup() {
      this.show = false;
      this.loginVal();
    },
    loginVal() {
      console.log(this.fromrouter);
      var that = this;
      if (that.fromrouter == "app") {
        fetch
          .post("/lcj/doTask", { subCode: that.subCode, type: 5 })
          .then((result) => {
            that.newways();
          });
      } else {
        that.newways();
      }
    },
    newways() {
      console.log("进入");
      var that = this;
      fetch.post("/lcj/surTimes", { subCode: that.subCode }).then((res) => {
        if (res.code == 10000) {
          let data = res.data.surTimes;
          that.surTimes = data;
          if (data.isLogins == 1)
            showToast({ message: "抽盲盒次数+1", duration: 2000 });
        } else {
          showToast({ message: res.msg, duration: 2000 });
        }
      });
    },
    //抽盲盒
    luckydraw(num) {
      // that.popupshow = false;
      var that = this;
      that.prizeName = "";
      if (this.loginFlag) {
        if (this.surTimes > 0) {
          eventBuryingPoint("c_ytwxyx_01", "l_ytwxgcmsngs_01");
          fetch
            .post("/lcj/drawLottery", {
              subCode: that.subCode,
              deviceId: that.sbCode,
            })
            .then((res) => {
              if (res.code == 10000) {
                that.popupshow = true;
                let data = res.data;
                that.surTimes -= 1;
                if (data.length > 0) {
                  data.forEach((item) => {
                    that.prizeName =
                      that.prizeName.length > 0
                        ? that.prizeName + "+" + item.prizeName
                        : item.prizeName;
                  });
                  that.prizeLogoUrl = require("../assets/img/prizeHide.png");
                  that.xzyLogoUrl = require("../assets/img/xzy02.png");
                  that.xzyname = "虎年小状元";
                } else {
                  if (data.prizeUrl == "blqsxzy") {
                    that.prizeLogoUrl = require("../assets/img/prizeExperience.png");
                    that.xzyLogoUrl = require("../assets/img/xzy01.png");
                    that.xzyname = "博览群书小状元";
                  } else if (data.prizeUrl == "cfxzy") {
                    that.prizeLogoUrl = require("../assets/img/prizeRedEnvelopes.png");
                    that.xzyLogoUrl = require("../assets/img/xzy04.png");
                    that.xzyname = "财富小状元";
                  } else if (data.prizeUrl == "jsxzy") {
                    that.prizeLogoUrl = require("../assets/img/prizeScale.png");
                    that.xzyLogoUrl = require("../assets/img/xzy05.png");
                    that.xzyname = "健身小状元";
                  } else {
                    that.prizeLogoUrl = require("../assets/img/prizeIntegral.png");
                    that.xzyLogoUrl = require("../assets/img/xzy03.png");
                    that.xzyname = "美食小状元";
                  }
                  that.prizeName = data.prizeName;
                }
              } else {
                showToast({ message: res.msg, duration: 2000 });
              }
            });
        } else {
          showToast({
            message: "抽盲盒次数不够，点击获取次数增加",
            duration: 2000,
          });
        }
      } else {
        if (this.$root.channel == "gydj") {
          if (num == 10) {
          } else {
            this.handleRegister("cmh"); //登录页
            openService("", "1", "KDS_Register", "");
          }
        } else {
          window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //获取盲盒次数弹窗
    getmore(num) {
      var that = this;
      if (this.loginFlag) {
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxgmorecode_01");
        fetch.post("/lcj/taskList", { subCode: that.subCode }).then((res) => {
          if (res.code == 10000) {
            this.show = true;
            let data = res.data;
            that.share = data.share;
            that.kzb = data.kzb;
            that.gmzzfw = data.gmzzfw;
            that.invite = data.invite;
          } else {
            showToast({ message: res.msg, duration: 2000 });
          }
        });
      } else {
        if (this.$root.channel == "gydj") {
          if (num == 4) {
          } else {
            this.handleRegister("cs"); //登录页
            openService("", "1", "KDS_Register", "");
          }
        } else {
          window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //查看排行
    seeRanking(num) {
      eventBuryingPoint("c_ytwxyx_01", "l_ytwxph_01");
      if (this.loginFlag) {
        this.$router.push("/rankingList");
      } else {
        if (this.$root.channel == "gydj") {
          if (num == 4) {
          } else {
            this.handleRegister("ph"); //登录页
            openService("", "3", "KDS_Register", "");
          }
        } else {
           window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //我的奖品
    myPrize(num) {
      eventBuryingPoint("c_ytwxyx_01", "l_ytwxmyprize_01");
      if (this.loginFlag) {
        this.$router.push("/myprize");
      } else {
        if (this.$root.channel == "gydj") {
          if (num == 3) {
          } else {
            this.handleRegister("mp"); //登录页
            openService("", "3", "KDS_Register", "");
          }
        } else {
          window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //活动规则
    rulePage(num) {
      if (this.loginFlag) {
        this.$router.push("/rule");
      } else {
        if (this.$root.channel == "gydj") {
          if (num == 5) {
          } else {
            this.handleRegister("gz"); //登录页
            openService("", "3", "KDS_Register", "");
          }
        } else {
           window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //领取盲盒奖励
    blindprizePage(num) {
      if (this.loginFlag) {
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxlqmh_01");
        this.$router.push("/Blindprize");
      } else {
        if (this.$root.channel == "gydj") {
          if (num == 2) {
          } else {
            this.handleRegister("jl"); //登录页
            openService("", "3", "KDS_Register", "");
          }
        } else {
          window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //邀请好友
    goinvite(obj) {
      var that = this;
      if (this.loginFlag) {
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxinvite_01");
        if (that.invite >= 20 && obj == "confirm") {
          Dialog.confirm({
            title: "提示",
            message: "今日已邀请成功20位好友，再邀请将不再增加抽盲盒次数！",
            confirmButtonText: "继续邀请",
          }).then(() => {
            that.inviteLink();
          });
        } else {
          that.inviteLink();
        }
      } else {
        if (this.$root.channel == "gydj") {
          this.init();
        } else {
           window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //邀请好友链接生成
    inviteLink() {
      var that = this;
      fetch
        .post("/lcj/inviteCode", { subCode: that.subCode, type: 3 })
        .then((res) => {
          if (res.code == 10000) {
            let data = res.data.code;
            let code = data;
            if (res.data.surTimes == 0) {
              Dialog.alert({
                message:
                  "今天邀请注册专属红包已发放完毕，参与邀请注册仅可获得额外抽取盲盒次数奖励。若想获取红包，欢迎明日参与！",
              }).then(() => {
                // on close
                if (that.$root.channel == "gydj") {
                  var shareUrl =
                    config.F_BASEURL + `/818lcj/index.html?invitacode=${code}`;
                  var JSONData = {
                    title: "小手一戳，818福利等你来。",
                    content: "抽盲盒领红包、积分、体脂秤。",
                    URLString: shareUrl,
                    key: {
                      functionCode: "KDS_WebPageWithHead",
                      loginType: 0,
                      param: { webViewUrl: shareUrl },
                    },
                  };
                  openService("", "5", "FN_EMBED_H5_SHARE", JSONData);
                  // eventBuryingPoint("c_ytwxyx_01", "l_ytwxinvitation_01");
                } else {
                  // eventBuryingPoint("c_ytwxyx_01", "l_ytwxindex_01");
                  // showToast({ message: '点击右上角分享，邀请好友参与活动', duration: 2000 });
                }
              });
            } else {
              Dialog.alert({
                message:
                  "邀请注册专属红包今日还剩" +
                  res.data.surTimes +
                  "个，先完成先获取。",
              }).then(() => {
                // on close
                if (that.$root.channel == "gydj") {
                  var shareUrl =
                    config.F_BASEURL + `/818lcj/index.html?invitacode=${code}`;
                  var JSONData = {
                    title: "小手一戳，818福利等你来。",
                    content: "抽盲盒领红包、积分、体脂秤。",
                    URLString: shareUrl,
                    key: {
                      functionCode: "KDS_WebPageWithHead",
                      loginType: 0,
                      param: { webViewUrl: shareUrl },
                    },
                  };
                  openService("", "5", "FN_EMBED_H5_SHARE", JSONData);
                  // eventBuryingPoint("c_ytwxyx_01", "l_ytwxinvitation_01");
                } else {
                  // eventBuryingPoint("c_ytwxyx_01", "l_ytwxindex_01");
                  // showToast({ message: '点击右上角分享，邀请好友参与活动', duration: 2000 });
                }
              });
            }
          } else {
            showToast({ message: res.msg, duration: 2000 });
          }
        });
    },
    //分享
    goshare() {
      eventBuryingPoint("c_ytwxyx_01", "l_ytwxshares_01");
      var that = this;
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("gydj") != -1) {
        fetch
          .post("/lcj/doTask", { subCode: that.subCode, type: 2 })
          .then((res) => {
            if (res.code == 10000) {
              if (that.$root.channel == "gydj") {
                that.share = 1;
                var shareUrl = config.F_BASEURL + `/818lcj/index.html`;
                // var shareUrl =
                //   "http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsATmb6YXjxvUVmNbbM0srJNJwxXYWudaaT41pRYq9WPcbrvNVQ6EWFZ%E5%8A%A0%E5%8F%B7KftCTulf08Lj88xO2dS12EpiiG33kR8gyrlM3KUby6GmPfUPYJPi38rIDTrh2LbFlzAs%E5%8A%A0%E5%8F%B7R8cveTA==";
                var JSONData = {
                  title: "国元证券818理财直播节",
                  content: "抽盲盒，看直播，赢红包，与国元证券一起科学理财",
                  URLString: shareUrl,
                  key: {
                    functionCode: "KDS_WebPageWithHead",
                    loginType: 0,
                    param: { webViewUrl: shareUrl },
                  },
                };
                openService("", "5", "FN_EMBED_H5_SHARE", JSONData);
                // eventBuryingPoint("c_ytwxyx_01", "l_ytwxinvitation_01");
              } else {
                that.sharePage = true;
                // eventBuryingPoint("c_ytwxyx_01", "l_ytwxindex_01");
                // showToast({ message: '点击右上角分享，邀请好友参与活动', duration: 2000 });
              }
            } else {
              showToast({ message: res.msg, duration: 2000 });
            }
          });
      } else {
        that.share = true;
      }
    },
    //前往看直播
    goto(num, obj) {
      var that = this;
      if (that.loginFlag) {
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxseezb_01");
        fetch
          .post("/lcj/doTask", { subCode: that.subCode, type: 4 })
          .then((res) => {
            if (res.code == 10000 || res.code == 10013) {
              if (that.$root.channel == "gydj") {
                that.kzb = 1;
                // this.$router.push("/livebroadcast");
                let param = {
                  webUrl:
                    // "https://wx.gyzq.com.cn/wxfw/activity/2022/anjian/818zbzq/index.html",
                    "https://wx.gyzq.com.cn/wxfw/activity/2022/818zbzq/index.html",
                  // "http://60.166.4.238:48081/wxfw/resource/activity/2022/818zbzq/index.html"
                };
                that.loginVal();
                openService("BANNER", "3", "KDS_WebPageWithHead", param);

                return;
                // eventBuryingPoint("c_ytwxyx_01", "l_ytwxinvitation_01");
              } else {
                that.sharePage = true;
                // eventBuryingPoint("c_ytwxyx_01", "l_ytwxindex_01");
                // showToast({ message: '点击右上角分享，邀请好友参与活动', duration: 2000 });
              }
            } else {
              if (obj == "type") {
                this.$router.push("/livebroadcast");
              } else {
                showToast({ message: res.msg, duration: 2000 });
              }
            }
          });
      } else {
        if (this.$root.channel == "gydj") {
          if (num == 11) {
          } else {
            this.handleRegister("zb"); //登录页
            openService("", "3", "KDS_Register", "");
          }
        } else {
           window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //购买增值服务
    gotobuf(num, obj) {
      var that = this;
      if (this.loginFlag) {
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxzzfw_01");
        this.$router.push("/pselection");
      } else {
        if (this.$root.channel == "gydj") {
          if (num == 13) {
          } else {
            this.handleRegister("tgzq"); //登录页
            openService("", "3", "KDS_Register", "");
          }
        } else {
          window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
          //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
        }
      }
    },
    //投顾专区
    gotgzq(num) {
      showToast({ message: '活动已结束', duration: 2000 });
      // if (this.loginFlag) {
      //   eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzq_01");
      //   let param = {
      //     webUrl:
      //       // "https://wx.gyzq.com.cn/wxfw/activity/2022/anjian/818tgfhc/index.html",
      //       "https://wx.gyzq.com.cn/wxfw/activity/2022/818tgfhc/index.html",
      //     // "http://60.166.4.238:48081/wxfw/resource/activity/2022/818tgzq/index.html"
      //   };
      //   openService("BANNER", "3", "KDS_WebPageWithHead", param);
      //   return;
      // } else {
      //   if (this.$root.channel == "gydj") {
      //     if (num == 12) {
      //     } else {
      //       this.handleRegister("tgzq"); //登录页
      //       openService("", "3", "KDS_Register", "");
      //     }
      //   } else {
      //     window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MRs94Ng3s%E5%8A%A0%E5%8F%B7789L7WVaQlrnKzrxWAO2yQ%E5%8A%A0%E5%8F%B7nCDWmMubejw`;
      //     //  window.location.href = `http://www.gyzq.com.cn/gyzq/gydj/gydj.html?jumpUrl=new&key=If/dWxyj9uqR0Isy3EHjZ8LNjhBkKAfEY92npupKsSc0EurMvIEKhXWVtMDoeqL/K/i%E5%8A%A0%E5%8F%B7Ftyvm0TeF2aVFZsAToDQ2OlYjmzm3p4Jr07kc9CtFSQO6btUYldzVeN9%E5%8A%A0%E5%8F%B7NiwMkM9BvXuJKDLN9KwT%E5%8A%A0%E5%8F%B7W7MSuC6TAnrk1ST/r6lj3DgvUYFujOHFbn7c6PE0KUoIPSsYOcu8Nx9Y4J2mJDNVRlZA==`;
      //   }
      // }
    },

    init() {
      var that = this;
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("gydj") != -1) {
        that.$root.channel = "gydj";
        window.setOpenState = function (state) {
          var deviceInfo = JSON.parse(state);
          if (deviceInfo.functionCode == "KDS_Register") {
            var State = deviceInfo.result.state;
            if (+State == 1) {
              //注册成功
              that.getUserInfo(); //验证登录状态
              that.handleRegister();
              return;
            }
          }

          if (deviceInfo.functionCode == "FN_EMBED_H5_USERINFO") {
            var num = deviceInfo.result.str;
            that.$root.accountNo = num;
            that.checkAccountNo(num);
          }

          if (deviceInfo.functionCode == "FN_EMBED_H5_DEVICEINFO") {
            that.sbCode = deviceInfo.result.str;
          }
        };
        that.getUserInfo(); //获取用户登录信息
        pageBuryingPoint("p_ytwx818lcj_01");
      } else {
        that.$root.channel = "qita";
      }
    },

    //检测活动状态
    checkAct(num) {
      var that = this;
      var param = {
        subCode: that.subCode,
      };
      //判断活动状态
      fetch.post("/wxyx/checkAct", param).then(
        (res) => {},
        (err) => {
          // var _tipsText = err.error_info || err.message;
          // showToast({ message: _tipsText, duration: 2000 });
        }
      );
    },

    handleRegister: function (type) {
      var that = this;
      window.setOpenState = function (state) {
        var deviceInfo = JSON.parse(state);
        var ua = window.navigator.userAgent.toLowerCase();
        var State;
        if (deviceInfo.functionCode == "KDS_Register") {
          State = deviceInfo.result.state;
          if (+State == 1) {
            //注册成功
            that.getUserInfo(); //验证登录状态
            that.handleRegister(type);
            return;
          }
        }
        if (deviceInfo.functionCode == "FN_EMBED_H5_USERINFO") {
          //获取资金状态
          var num = deviceInfo.result.str;
          that.$set(that, "accountNo", num);
          that.checkAccountNo(num);
          if (type == "gz") {
            that.checkAccountNo(num, that.rulePage, 5);
          } else if (type == "ph") {
            that.checkAccountNo(num, that.seeRanking, 4);
          } else if (type == "mp") {
            that.checkAccountNo(num, that.myPrize, 3);
          } else if (type == "jl") {
            that.checkAccountNo(num, that.blindprizePage, 2);
          } else if (type == "cs") {
            that.checkAccountNo(num, that.getmore, 1);
          } else if (type == "cmh") {
            that.checkAccountNo(num, that.luckydraw, 10);
          } else if (type == "zb") {
            that.checkAccountNo(num, that.goto, 11);
          } else if (type == "tgzq") {
            that.checkAccountNo(num, that.gotgzq, 12);
          } else if (type == "tgzq") {
            that.checkAccountNo(num, that.gotobuf, 13);
          } else {
            that.checkAccountNo(num);
          }
        }
      };
    },
    //获取用户信息
    getUserInfo() {
      var JSONData = {
        mark: "mark",
        key: "OLDmkHpviT4P!34g",
        iv: "!wpgXOqxFt%J99Tb",
      };
      openService("", "5", "FN_EMBED_H5_USERINFO", JSONData);
      openService("", "5", "FN_EMBED_H5_DEVICEINFO", JSONData);
    },

    //检测是否登录
    checkAccountNo(num, callBack, type) {
      var that = this;
      fetch
        .post("/wxyx/loginApp", {
          accountNo: num,
          subCode: that.subCode,
        })
        .then((res) => {
          if (res.code == 10000) {
            let data = res.data;
            if (data.phoneState) {
              //已登录
              that.$set(that, "accountNo", num);
              that.$set(that, "loginFlag", true);
              that.$root.loginFlag = true;
              that.loginVal();

              if (typeof callBack === "function") {
                let param = type;
                callBack(param);
              }
            } else {
              that.$set(that, "loginFlag", false);
              that.$root.loginFlag = false;
              openService("", "3", "KDS_Register", "");
              // that.$root.isDrawIntegral = false;
            }
          } else {
            that.$set(that, "loginFlag", false);
            that.$root.loginFlag = false;
          }

          // if (typeof callBack === "function") {
          //   let num = type;
          //   callBack(num);
          // }
        });
    },

    formatDate(now) {
      let nowTime = new Date(now);
      var year = nowTime.getFullYear(); //取得4位数的年份
      var month = nowTime.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
      var date = nowTime.getDate(); //返回日期月份中的天数（1到31）
      if (date < 10) {
        date = "0" + date;
      } else {
        date = nowTime.getDate();
      }
      // var hour = nowTime.getHours(); //返回日期中的小时数（0到23）
      // var minute = nowTime.getMinutes(); //返回日期中的分钟数（0到59）
      // var second = nowTime.getSeconds(); //返回日期中的秒数（0到59）
      return year + "." + month + "." + date;
    },

    /**
     * 图片禁止预览
     * @param {Object} e event对象
     */
    handleForbidPreview(e) {
      e.preventDefault() && e.stopPropagation();
    },
  },
};
</script>

<style lang="less">
.h5-toast {
  z-index: 3000;
}
.van-dialog {
  z-index: 90000 !important;
}
.van-dialog__message {
  font-size: 0.32rem;
}
</style>
